// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3KDvI","modalForm":"UpgradeEpcsModal_modalForm__Yie94","modalFooter":"UpgradeEpcsModal_modalFooter__2iOdC"};